import React from 'react';
import { Field, FieldProps } from 'formik';
import styled from 'styled-components';

import { Label, InputContainer, InputElementProps, defaultInputBoxCSS } from '../../FormHelpers';
import { TextWidgetSpec, StringWidgetType, StringField } from '../../../../../../client/forms';
import { ErrorLabel } from '../../ErrorMessageLabel/ErrorMessageLabel';

interface Props {
  field: StringField<TextWidgetSpec>;
}

export const TextWidgetComponent: React.FC<Props> = (props) => {
  const { key: name } = props.field;
  return <Field name={name} component={Component} notificationField={props.field} />;
};

interface ComponentProps extends FieldProps {
  notificationField: Props['field'];
}

const Component: React.FC<ComponentProps> = (props) => {
  const { field, form, notificationField, ...rest } = props;
  const { placeholder } = notificationField.widget;
  const label = notificationField.label;
  const error = form.errors[field.name];

  const handleInitialChange = () => {
    if (!form.touched[field.name]) {
      form.setFieldTouched(field.name);
    }
  };

  return (
    <InputContainer flexDirection="column">
      {label && <Label>{label}</Label>}
      <InputElement
        type="text"
        onChangeCapture={handleInitialChange}
        autoComplete="off"
        placeholder={placeholder}
        $validationError={!!error && !!form.touched[field.name]}
        data-type={StringWidgetType.Text}
        {...rest}
        {...field}
      />
      <ErrorLabel name={field.name} />
    </InputContainer>
  );
};

const InputElement = styled.input<InputElementProps>`
  ${defaultInputBoxCSS};
`;
